export const initialState = {
  title: 'Reset Password | Northwestern Mutual',
  fromUri: '',
  nmUniqueId: 'no_user',
  isLunaLiteEnabled: false,
  supportHours: ''
}

export default (state = initialState) => state
